var map = {
	"./Group-4911.svg": "75df",
	"./Group-5030.svg": "0b17",
	"./Group-5119.svg": "6c13",
	"./Group-5120.svg": "929c",
	"./Group-5122.svg": "f3a7",
	"./Group-5125.svg": "d99e",
	"./Group-blank.svg": "024b",
	"./LMS-Courses-0.svg": "9992",
	"./LMS-Courses-2.svg": "9f68",
	"./LMS-Courses-4.svg": "13cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3972";